import {
  SET_SLOTS,
  SET_PREVIOUS_SLOTS,
  SET_NEXT_SLOTS,
  SET_FILTERS,
  REPLACE_FILTERS,
} from './select-date.actions';

const initialState = {
  slots: [],
  filters: [],
};

export const selectDateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SLOTS:
      return {
        ...state,
        slots: [...payload],
      };
    case SET_NEXT_SLOTS: {
      return {
        ...state,
        slots: [...state.slots, ...payload],
      };
    }
    case SET_PREVIOUS_SLOTS: {
      return {
        ...state,
        slots: [...payload, ...state.slots],
      };
    }
    case SET_FILTERS: {
      const filterIndex = state.filters.findIndex((filter) => filter === payload);
      return {
        ...state,
        filters:
          filterIndex > -1
            ? [...state.filters.slice(0, filterIndex), ...state.filters.slice(filterIndex + 1)]
            : [...state.filters, payload],
      };
    }
    case REPLACE_FILTERS: {
      return {
        ...state,
        filters: payload,
      };
    }
    default:
      return state;
  }
};
